module.exports = __webpack_public_path__ + "img/table.dce9893b.jpg";